// extracted by mini-css-extract-plugin
export default {"drawer":"styles_drawer__GqEty","drawerContent":"styles_drawerContent__RPnE7","heading":"styles_heading__XmmKm","drawerBody":"styles_drawerBody__giQZK"};